import { SimpleListEntitiesAllowedEnum, SimpleListEntitiesRequest, SimpleListEntitiesResponse } from '@/api/resources/common/simple-list-entities/simple-list-entities.dto'
import axios from 'axios'

class CommonSimpleListEntity {
    async getListOfEntity(entity: SimpleListEntitiesAllowedEnum, params?: SimpleListEntitiesRequest): Promise<SimpleListEntitiesResponse> {
        const response = await axios.get<SimpleListEntitiesResponse>(`/simpleList/${entity}`, { params })
        return response.data
    }
}

export const commonSimpleListEntity = new CommonSimpleListEntity()
